export const menuData = [
	{ title: "About", link: "/about" },
	{ title: "Newest Projects", link: "/projects" },
	{ title: "How we work", link: "/rentals" },
];